<template>
  <div class="api-keys-main">
    <el-card class="api-keys-info info-item">
      <div class="info-top">
        <div class="info-left">
          <div class="info-title">API Keys</div>
          <div class="info-title-desc">管理您的API Keys以验证您的请求</div>
        </div>
        <div class="info-right">
          <el-button type="primary" @click="goToCreate">创建API Key</el-button>
        </div>
      </div>

      <div class="info-data">
        <el-table
          :data="apiKeysList"
          style="width: 100%"
          :default-sort="{ prop: 'created_at', order: 'descending' }"
          v-if="apiKeysList.length > 0"
        >
          <!-- 添加这些列定义 -->
          <el-table-column prop="api_key_name" label="名称"></el-table-column>
          <el-table-column prop="service_api_key" label="KEY"></el-table-column>
          <el-table-column
            prop="created_at"
            :formatter="parseTimeFormatter"
            label="创建时间"
          ></el-table-column>
          <!-- <el-table-column prop="latest_time" label="最后使用时间">
            <template #default="scope">
              <el-tag v-if="scope.row.latest_time">{{ parseTime(scope.row.latest_time) }}</el-tag>
              <el-tag v-else>从未使用</el-tag>
            </template>
          </el-table-column> -->
          <el-table-column>
            <template #default="scope">
              <el-button type="danger" icon="Delete" @click="deleteApiKeyFn(scope.row)" />
            </template>
          </el-table-column>
        </el-table>
        <el-empty class="info-empty" v-else>
          <template #description>
            <div class="info-empty-title">
              您还没有创建 API Key。<el-link @click="goToCreate"
                >点击此处生成您的第一个 API 密钥。</el-link
              >
            </div>
          </template>
        </el-empty>
      </div>
    </el-card>
  </div>
  <el-dialog
    title="创建新的API Key"
    v-model="dataRef.dialogCreateVisible"
    @close="hiddenDialogCreateVisible"
  >
    <el-form
      ref="createApiKeyFromRef"
      :model="createApiKeyFrom"
      :rules="createApiKeyRule"
      label-width="120px"
      @submit.prevent="createApiKeyFn(createApiKeyFromRef)"
    >
      <el-form-item label="名称" prop="mnemonic">
        <!-- 修改这一行，确保v-model绑定的是createApiKeyFrom对象的mnemonic属性 -->
        <el-input v-model="createApiKeyFrom.mnemonic" placeholder="请输入名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="createApiKeyFn(createApiKeyFromRef)">创建</el-button>
        <el-button @click="hiddenDialogCreateVisible">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
  <el-dialog
    title="API Key"
    v-model="dataRef.dialogCopyVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    style="width: 530px"
  >
    <div class="tip">
      <el-icon :size="20">
        <Warning />
      </el-icon>
      <span>立即保存此密钥。你以后再也见不到它了。</span>
    </div>
    <el-form ref="getAPIKeyFormRef" :model="getApiKeyData" label-width="60px">
      <el-form-item label="名称">
        <el-input disabled v-model="getApiKeyData.api_key_name" placeholder="请输入名称"></el-input>
      </el-form-item>
      <el-form-item label="密钥">
        <el-input readonly v-model="getApiKeyData.service_api_key" placeholder="请输入密钥">
          <template #suffix>
            <el-button
              icon="CopyDocument"
              class="copy-icon-btn"
              @click="copyToClipboard(getApiKeyData.service_api_key)"
            ></el-button>
          </template>
        </el-input>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script setup>
import { createApiKey, deleteApiKey, getApiKeyList } from '@/api/apikey'
import { ElMessage, ElMessageBox } from 'element-plus'
import { onMounted, reactive, ref } from 'vue'
import { parseTime } from '@/utils'
import { parseTimeFormatter } from '@/utils/formatter'

const serviceId = 4
const createApiKeyFromRef = ref(null)
const dataRef = reactive({
  dialogCreateVisible: false,
  dialogCopyVisible: false,
})
const createApiKeyFrom = reactive({
  mnemonic: '',
})
const createApiKeyRule = {
  mnemonic: [
    { required: true, message: '请输入名称', trigger: 'blur' },
    { min: 3, max: 30, message: '长度在 3 到 30 个字符', trigger: 'blur' },
    // 正则匹配，如果不满足 /^[a-zA-Z0-9_-]+$/，提示名称包含非法字符，只能包含大写、小写英文字符、数字、-_
    {
      pattern: /^[a-zA-Z0-9_-]+$/,
      message: '名称包含非法字符，只能包含大写、小写英文字符、数字、-_',
      trigger: 'blur',
    },
    { trigger: 'blur', validator: checkApiKeyName },
  ],
}

const getApiKeyData = reactive({
  api_key_name: '',
  service_api_key: '',
})

let apiKeysList = ref([])

onMounted(() => {
  getApiKeysListFn()
})

function checkApiKeyName(rule, value, callback) {
  console.log('checkApiKeyName', apiKeysList.value)
  for (let i = 0; i < apiKeysList.value.length; i++) {
    if (apiKeysList.value[i].api_key_name === value) {
      callback(new Error('已经存在相同名字的API Key'))
    }
  }

  callback && callback()
}
async function getApiKeysListFn() {
  let res = await getApiKeyList({ service_id: serviceId })
  if (res.data.ret == 0) {
    apiKeysList.value = res.data.data.list
  }
}

const copyToClipboard = (text) => {
  if (navigator.clipboard) {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        ElMessage.success('已复制到剪贴板')
      })
      .catch((err) => {
        ElMessage.error('复制失败')
        console.error('复制失败:', err)
      })
  } else {
    // 兼容性处理：对于不支持 Clipboard API 的浏览器
    const textarea = document.createElement('textarea')
    textarea.value = text
    document.body.appendChild(textarea)
    textarea.select()
    try {
      document.execCommand('copy')
      ElMessage.success('已复制到剪贴板')
    } catch (err) {
      ElMessage.error('复制失败')
      console.error('复制失败:', err)
    }
    document.body.removeChild(textarea)
  }
}

function goToCreate() {
  dataRef.dialogCreateVisible = true
}

function hiddenDialogCreateVisible() {
  dataRef.dialogCreateVisible = false
  createApiKeyFrom.mnemonic = ''
  createApiKeyFromRef.value.clearValidate()
}

async function createApiKeyFn(formEl) {
  if (!formEl) return
  formEl.clearValidate()
  await formEl.validate(async (valid, fields) => {
    if (valid) {
      let res = await createApiKey({
        service_id: serviceId,
        mnemonic: createApiKeyFrom.mnemonic,
      })

      if (res.data.ret == 0) {
        dataRef.dialogCreateVisible = false
        dataRef.dialogCopyVisible = true
        getApiKeyData.api_key_name = res.data.data.api_key_name
        getApiKeyData.service_api_key = res.data.data.service_api_key
        getApiKeysListFn()
      } else if (res.data.ret == 4) {
        ElMessage.error('已经存在相同名字的API Key')
        getApiKeysListFn()
      } else if (res.data.ret == 40004) {
        ElMessage.error('名称包含非法字符，只能包含大写、小写英文字符、数字、-_')
      } else if (res.data.ret == 40006) {
        ElMessage.error('Api key 超过允许的数量')
      } else {
        ElMessage.error(res.data.msg)
      }
    } else {
      console.log('error submit!!')
    }
  })
}
async function deleteApiKeyFn(row) {
  if (!row) return

  ElMessageBox.confirm(
    `此操作将永久删除该API Key "${row.api_key_name}"，且无法回退, 是否继续?`,
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(async () => {
      // 删除API Key
      let res = await deleteApiKey({
        mnemonic: row.api_key_name,
      })
      if (res.data.ret == 0) {
        ElMessage.success('删除成功')
        getApiKeysListFn()
      } else {
        ElMessage.error(res.data.msg)
      }
    })
    .catch(() => {
      // ElMessage({
      //   type: 'info',
      //   message: '已取消删除',
      // })
    })
}
</script>

<style lang="scss" scoped>
.copy-icon-btn {
  background-color: transparent !important;
  color: #fff;
  border: none;

  &:hover {
    color: #ccc;
    background-color: #393838 !important;
  }
}

.tip {
  border: 1px solid rgb(252, 211, 77);
  border-radius: 4px;
  margin-bottom: 16px;
  color: rgb(146, 64, 14);
  background: rgb(255, 251, 235);
  display: flex;
  padding: 10px 20px;
  align-items: center;
  span {
    margin-left: 10px;
  }
}
</style>
